var current;

var DomEventsBuilder = function DomEventsBuilder () {};

DomEventsBuilder.register = function register (userImplementation) {
    current = userImplementation;
};

DomEventsBuilder.create = function create (element, events) {
    if (current) {
        return current.create(element, events);
    }
};

export default DomEventsBuilder;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/services/dom-events-builder.js
// module id = 1887
// module chunks = 29